import { render, staticRenderFns } from "./TutorRegistrationCompleted.vue?vue&type=template&id=ad351d60&scoped=true&"
import script from "./TutorRegistrationCompleted.vue?vue&type=script&lang=js&"
export * from "./TutorRegistrationCompleted.vue?vue&type=script&lang=js&"
import style0 from "./TutorRegistrationCompleted.vue?vue&type=style&index=0&id=ad351d60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad351d60",
  null
  
)

export default component.exports